/* tslint:disable */
/* eslint-disable */
/**
 * Bioplan API
 * Backend API for Bioplan, an aquaculture production planning tool.
 *
 * Contact: support@optimeeringaqua.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type {Configuration} from '../configuration';
import type {AxiosPromise, AxiosInstance, RawAxiosRequestConfig} from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import {
  DUMMY_BASE_URL,
  assertParamExists,
  setApiKeyToObject,
  setBasicAuthToObject,
  setBearerAuthToObject,
  setOAuthToObject,
  setSearchParams,
  serializeDataIfNeeded,
  toPathString,
  createRequestFunction,
} from '../common';
// @ts-ignore
import {BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap} from '../base';
// @ts-ignore
import type {AddSalesPriceModel} from '../bioplanModels';
// @ts-ignore
import type {CopySalesPriceModel} from '../bioplanModels';
// @ts-ignore
import type {EditSalesPriceModelCell} from '../bioplanModels';
// @ts-ignore
import type {MigrateSalesPriceModel} from '../bioplanModels';
// @ts-ignore
import type {SalesClassModelType} from '../bioplanModels';
// @ts-ignore
import type {SalesPriceModel} from '../bioplanModels';
// @ts-ignore
import type {SalesPriceModelRow} from '../bioplanModels';
/**
 * SalesPriceModelsApi - axios parameter creator
 * @export
 */
export const SalesPriceModelsApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @summary Copy a sales price model
     * @param {CopySalesPriceModel} copySalesPriceModel
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    salesPriceModelsCopyPost: async (
      copySalesPriceModel: CopySalesPriceModel,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'copySalesPriceModel' is not null or undefined
      assertParamExists('salesPriceModelsCopyPost', 'copySalesPriceModel', copySalesPriceModel);
      const localVarPath = `/salesPriceModels/copy`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'POST', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      localVarRequestOptions.data = serializeDataIfNeeded(copySalesPriceModel, localVarRequestOptions, configuration);

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Get all sales price models for user\'s tenant
     * @param {string} planId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    salesPriceModelsGet: async (planId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
      // verify required parameter 'planId' is not null or undefined
      assertParamExists('salesPriceModelsGet', 'planId', planId);
      const localVarPath = `/salesPriceModels/`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'GET', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (planId !== undefined) {
        localVarQueryParameter['planId'] = planId;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Import export sales price model in JSON format
     * @param {string} planId
     * @param {MigrateSalesPriceModel} migrateSalesPriceModel
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    salesPriceModelsImportJSONPlanIdPost: async (
      planId: string,
      migrateSalesPriceModel: MigrateSalesPriceModel,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'planId' is not null or undefined
      assertParamExists('salesPriceModelsImportJSONPlanIdPost', 'planId', planId);
      // verify required parameter 'migrateSalesPriceModel' is not null or undefined
      assertParamExists('salesPriceModelsImportJSONPlanIdPost', 'migrateSalesPriceModel', migrateSalesPriceModel);
      const localVarPath = `/salesPriceModels/importJSON/{planId}`.replace(
        `{${'planId'}}`,
        encodeURIComponent(String(planId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'POST', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      localVarRequestOptions.data = serializeDataIfNeeded(
        migrateSalesPriceModel,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Import sales prices from Excel file
     * @param {File} file
     * @param {string} name
     * @param {string} planId
     * @param {string} type
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    salesPriceModelsImportPost: async (
      file: File,
      name: string,
      planId: string,
      type: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'file' is not null or undefined
      assertParamExists('salesPriceModelsImportPost', 'file', file);
      // verify required parameter 'name' is not null or undefined
      assertParamExists('salesPriceModelsImportPost', 'name', name);
      // verify required parameter 'planId' is not null or undefined
      assertParamExists('salesPriceModelsImportPost', 'planId', planId);
      // verify required parameter 'type' is not null or undefined
      assertParamExists('salesPriceModelsImportPost', 'type', type);
      const localVarPath = `/salesPriceModels/import`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'POST', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;
      const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (file !== undefined) {
        localVarFormParams.append('file', file as any);
      }

      if (name !== undefined) {
        localVarFormParams.append('name', name as any);
      }

      if (planId !== undefined) {
        localVarFormParams.append('planId', planId as any);
      }

      if (type !== undefined) {
        localVarFormParams.append('type', type as any);
      }

      localVarHeaderParameter['Content-Type'] = 'multipart/form-data';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      localVarRequestOptions.data = localVarFormParams;

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    salesPriceModelsImportTemplateGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
      const localVarPath = `/salesPriceModels/import/template`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'GET', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Delete sales price model by its identifier
     * @param {string} modelId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    salesPriceModelsModelIdDelete: async (
      modelId: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'modelId' is not null or undefined
      assertParamExists('salesPriceModelsModelIdDelete', 'modelId', modelId);
      const localVarPath = `/salesPriceModels/{modelId}`.replace(`{${'modelId'}}`, encodeURIComponent(String(modelId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'DELETE', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Export sales price model as JSON
     * @param {string} modelId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    salesPriceModelsModelIdExportGet: async (
      modelId: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'modelId' is not null or undefined
      assertParamExists('salesPriceModelsModelIdExportGet', 'modelId', modelId);
      const localVarPath = `/salesPriceModels/{modelId}/export`.replace(
        `{${'modelId'}}`,
        encodeURIComponent(String(modelId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'GET', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Get sales price model by its identifier
     * @param {string} modelId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    salesPriceModelsModelIdGet: async (modelId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
      // verify required parameter 'modelId' is not null or undefined
      assertParamExists('salesPriceModelsModelIdGet', 'modelId', modelId);
      const localVarPath = `/salesPriceModels/{modelId}`.replace(`{${'modelId'}}`, encodeURIComponent(String(modelId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'GET', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Update sales price model name
     * @param {string} modelId
     * @param {SalesPriceModel} salesPriceModel
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    salesPriceModelsModelIdPut: async (
      modelId: string,
      salesPriceModel: SalesPriceModel,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'modelId' is not null or undefined
      assertParamExists('salesPriceModelsModelIdPut', 'modelId', modelId);
      // verify required parameter 'salesPriceModel' is not null or undefined
      assertParamExists('salesPriceModelsModelIdPut', 'salesPriceModel', salesPriceModel);
      const localVarPath = `/salesPriceModels/{modelId}`.replace(`{${'modelId'}}`, encodeURIComponent(String(modelId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'PUT', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      localVarRequestOptions.data = serializeDataIfNeeded(salesPriceModel, localVarRequestOptions, configuration);

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Delete sales price row by its identifier (fromDate)
     * @param {string} modelId
     * @param {string} fromDate
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    salesPriceModelsModelIdRowsFromDateDelete: async (
      modelId: string,
      fromDate: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'modelId' is not null or undefined
      assertParamExists('salesPriceModelsModelIdRowsFromDateDelete', 'modelId', modelId);
      // verify required parameter 'fromDate' is not null or undefined
      assertParamExists('salesPriceModelsModelIdRowsFromDateDelete', 'fromDate', fromDate);
      const localVarPath = `/salesPriceModels/{modelId}/rows/{fromDate}`
        .replace(`{${'modelId'}}`, encodeURIComponent(String(modelId)))
        .replace(`{${'fromDate'}}`, encodeURIComponent(String(fromDate)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'DELETE', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Update single sales price
     * @param {string} modelId
     * @param {string} fromDate
     * @param {EditSalesPriceModelCell} editSalesPriceModelCell
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    salesPriceModelsModelIdRowsFromDatePatch: async (
      modelId: string,
      fromDate: string,
      editSalesPriceModelCell: EditSalesPriceModelCell,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'modelId' is not null or undefined
      assertParamExists('salesPriceModelsModelIdRowsFromDatePatch', 'modelId', modelId);
      // verify required parameter 'fromDate' is not null or undefined
      assertParamExists('salesPriceModelsModelIdRowsFromDatePatch', 'fromDate', fromDate);
      // verify required parameter 'editSalesPriceModelCell' is not null or undefined
      assertParamExists('salesPriceModelsModelIdRowsFromDatePatch', 'editSalesPriceModelCell', editSalesPriceModelCell);
      const localVarPath = `/salesPriceModels/{modelId}/rows/{fromDate}`
        .replace(`{${'modelId'}}`, encodeURIComponent(String(modelId)))
        .replace(`{${'fromDate'}}`, encodeURIComponent(String(fromDate)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'PATCH', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      localVarRequestOptions.data = serializeDataIfNeeded(
        editSalesPriceModelCell,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Update sales price row originally identified by the \'fromDate\' passed in the route
     * @param {string} modelId
     * @param {string} fromDate
     * @param {SalesPriceModelRow} salesPriceModelRow
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    salesPriceModelsModelIdRowsFromDatePut: async (
      modelId: string,
      fromDate: string,
      salesPriceModelRow: SalesPriceModelRow,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'modelId' is not null or undefined
      assertParamExists('salesPriceModelsModelIdRowsFromDatePut', 'modelId', modelId);
      // verify required parameter 'fromDate' is not null or undefined
      assertParamExists('salesPriceModelsModelIdRowsFromDatePut', 'fromDate', fromDate);
      // verify required parameter 'salesPriceModelRow' is not null or undefined
      assertParamExists('salesPriceModelsModelIdRowsFromDatePut', 'salesPriceModelRow', salesPriceModelRow);
      const localVarPath = `/salesPriceModels/{modelId}/rows/{fromDate}`
        .replace(`{${'modelId'}}`, encodeURIComponent(String(modelId)))
        .replace(`{${'fromDate'}}`, encodeURIComponent(String(fromDate)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'PUT', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      localVarRequestOptions.data = serializeDataIfNeeded(salesPriceModelRow, localVarRequestOptions, configuration);

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Get all rows for the sales price model with \'modelId\'
     * @param {string} modelId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    salesPriceModelsModelIdRowsGet: async (
      modelId: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'modelId' is not null or undefined
      assertParamExists('salesPriceModelsModelIdRowsGet', 'modelId', modelId);
      const localVarPath = `/salesPriceModels/{modelId}/rows/`.replace(
        `{${'modelId'}}`,
        encodeURIComponent(String(modelId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'GET', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Add row to sales price model with \'modelId\'
     * @param {string} modelId
     * @param {SalesPriceModelRow} salesPriceModelRow
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    salesPriceModelsModelIdRowsPost: async (
      modelId: string,
      salesPriceModelRow: SalesPriceModelRow,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'modelId' is not null or undefined
      assertParamExists('salesPriceModelsModelIdRowsPost', 'modelId', modelId);
      // verify required parameter 'salesPriceModelRow' is not null or undefined
      assertParamExists('salesPriceModelsModelIdRowsPost', 'salesPriceModelRow', salesPriceModelRow);
      const localVarPath = `/salesPriceModels/{modelId}/rows/`.replace(
        `{${'modelId'}}`,
        encodeURIComponent(String(modelId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'POST', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      localVarRequestOptions.data = serializeDataIfNeeded(salesPriceModelRow, localVarRequestOptions, configuration);

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Create sales price model for user\'s tenant
     * @param {AddSalesPriceModel} addSalesPriceModel
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    salesPriceModelsPost: async (
      addSalesPriceModel: AddSalesPriceModel,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'addSalesPriceModel' is not null or undefined
      assertParamExists('salesPriceModelsPost', 'addSalesPriceModel', addSalesPriceModel);
      const localVarPath = `/salesPriceModels/`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'POST', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      localVarRequestOptions.data = serializeDataIfNeeded(addSalesPriceModel, localVarRequestOptions, configuration);

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Get all types of sales price models and the corresponding weight classes
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    salesPriceModelsTypesGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
      const localVarPath = `/salesPriceModels/types`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'GET', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Get sales price model type by its identifier
     * @param {string} modelType
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    salesPriceModelsTypesModelTypeGet: async (
      modelType: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'modelType' is not null or undefined
      assertParamExists('salesPriceModelsTypesModelTypeGet', 'modelType', modelType);
      const localVarPath = `/salesPriceModels/types/{modelType}`.replace(
        `{${'modelType'}}`,
        encodeURIComponent(String(modelType)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'GET', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * SalesPriceModelsApi - functional programming interface
 * @export
 */
export const SalesPriceModelsApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = SalesPriceModelsApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @summary Copy a sales price model
     * @param {CopySalesPriceModel} copySalesPriceModel
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async salesPriceModelsCopyPost(
      copySalesPriceModel: CopySalesPriceModel,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SalesPriceModel>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.salesPriceModelsCopyPost(copySalesPriceModel, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['SalesPriceModelsApi.salesPriceModelsCopyPost']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Get all sales price models for user\'s tenant
     * @param {string} planId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async salesPriceModelsGet(
      planId: string,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<SalesPriceModel>>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.salesPriceModelsGet(planId, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['SalesPriceModelsApi.salesPriceModelsGet']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Import export sales price model in JSON format
     * @param {string} planId
     * @param {MigrateSalesPriceModel} migrateSalesPriceModel
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async salesPriceModelsImportJSONPlanIdPost(
      planId: string,
      migrateSalesPriceModel: MigrateSalesPriceModel,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SalesPriceModel>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.salesPriceModelsImportJSONPlanIdPost(
        planId,
        migrateSalesPriceModel,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['SalesPriceModelsApi.salesPriceModelsImportJSONPlanIdPost']?.[localVarOperationServerIndex]
          ?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Import sales prices from Excel file
     * @param {File} file
     * @param {string} name
     * @param {string} planId
     * @param {string} type
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async salesPriceModelsImportPost(
      file: File,
      name: string,
      planId: string,
      type: string,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SalesPriceModel>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.salesPriceModelsImportPost(
        file,
        name,
        planId,
        type,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['SalesPriceModelsApi.salesPriceModelsImportPost']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async salesPriceModelsImportTemplateGet(
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.salesPriceModelsImportTemplateGet(options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['SalesPriceModelsApi.salesPriceModelsImportTemplateGet']?.[localVarOperationServerIndex]
          ?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Delete sales price model by its identifier
     * @param {string} modelId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async salesPriceModelsModelIdDelete(
      modelId: string,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.salesPriceModelsModelIdDelete(modelId, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['SalesPriceModelsApi.salesPriceModelsModelIdDelete']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Export sales price model as JSON
     * @param {string} modelId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async salesPriceModelsModelIdExportGet(
      modelId: string,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MigrateSalesPriceModel>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.salesPriceModelsModelIdExportGet(modelId, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['SalesPriceModelsApi.salesPriceModelsModelIdExportGet']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Get sales price model by its identifier
     * @param {string} modelId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async salesPriceModelsModelIdGet(
      modelId: string,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SalesPriceModel>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.salesPriceModelsModelIdGet(modelId, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['SalesPriceModelsApi.salesPriceModelsModelIdGet']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Update sales price model name
     * @param {string} modelId
     * @param {SalesPriceModel} salesPriceModel
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async salesPriceModelsModelIdPut(
      modelId: string,
      salesPriceModel: SalesPriceModel,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SalesPriceModel>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.salesPriceModelsModelIdPut(
        modelId,
        salesPriceModel,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['SalesPriceModelsApi.salesPriceModelsModelIdPut']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Delete sales price row by its identifier (fromDate)
     * @param {string} modelId
     * @param {string} fromDate
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async salesPriceModelsModelIdRowsFromDateDelete(
      modelId: string,
      fromDate: string,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.salesPriceModelsModelIdRowsFromDateDelete(
        modelId,
        fromDate,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['SalesPriceModelsApi.salesPriceModelsModelIdRowsFromDateDelete']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Update single sales price
     * @param {string} modelId
     * @param {string} fromDate
     * @param {EditSalesPriceModelCell} editSalesPriceModelCell
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async salesPriceModelsModelIdRowsFromDatePatch(
      modelId: string,
      fromDate: string,
      editSalesPriceModelCell: EditSalesPriceModelCell,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.salesPriceModelsModelIdRowsFromDatePatch(
        modelId,
        fromDate,
        editSalesPriceModelCell,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['SalesPriceModelsApi.salesPriceModelsModelIdRowsFromDatePatch']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Update sales price row originally identified by the \'fromDate\' passed in the route
     * @param {string} modelId
     * @param {string} fromDate
     * @param {SalesPriceModelRow} salesPriceModelRow
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async salesPriceModelsModelIdRowsFromDatePut(
      modelId: string,
      fromDate: string,
      salesPriceModelRow: SalesPriceModelRow,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SalesPriceModelRow>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.salesPriceModelsModelIdRowsFromDatePut(
        modelId,
        fromDate,
        salesPriceModelRow,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['SalesPriceModelsApi.salesPriceModelsModelIdRowsFromDatePut']?.[localVarOperationServerIndex]
          ?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Get all rows for the sales price model with \'modelId\'
     * @param {string} modelId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async salesPriceModelsModelIdRowsGet(
      modelId: string,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<SalesPriceModelRow>>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.salesPriceModelsModelIdRowsGet(modelId, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['SalesPriceModelsApi.salesPriceModelsModelIdRowsGet']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Add row to sales price model with \'modelId\'
     * @param {string} modelId
     * @param {SalesPriceModelRow} salesPriceModelRow
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async salesPriceModelsModelIdRowsPost(
      modelId: string,
      salesPriceModelRow: SalesPriceModelRow,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SalesPriceModelRow>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.salesPriceModelsModelIdRowsPost(
        modelId,
        salesPriceModelRow,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['SalesPriceModelsApi.salesPriceModelsModelIdRowsPost']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Create sales price model for user\'s tenant
     * @param {AddSalesPriceModel} addSalesPriceModel
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async salesPriceModelsPost(
      addSalesPriceModel: AddSalesPriceModel,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SalesPriceModel>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.salesPriceModelsPost(addSalesPriceModel, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['SalesPriceModelsApi.salesPriceModelsPost']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Get all types of sales price models and the corresponding weight classes
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async salesPriceModelsTypesGet(
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<SalesClassModelType>>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.salesPriceModelsTypesGet(options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['SalesPriceModelsApi.salesPriceModelsTypesGet']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Get sales price model type by its identifier
     * @param {string} modelType
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async salesPriceModelsTypesModelTypeGet(
      modelType: string,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SalesClassModelType>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.salesPriceModelsTypesModelTypeGet(modelType, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['SalesPriceModelsApi.salesPriceModelsTypesModelTypeGet']?.[localVarOperationServerIndex]
          ?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
  };
};

/**
 * SalesPriceModelsApi - factory interface
 * @export
 */
export const SalesPriceModelsApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = SalesPriceModelsApiFp(configuration);
  return {
    /**
     *
     * @summary Copy a sales price model
     * @param {SalesPriceModelsApiSalesPriceModelsCopyPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    salesPriceModelsCopyPost(
      requestParameters: SalesPriceModelsApiSalesPriceModelsCopyPostRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<SalesPriceModel> {
      return localVarFp
        .salesPriceModelsCopyPost(requestParameters.copySalesPriceModel, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Get all sales price models for user\'s tenant
     * @param {SalesPriceModelsApiSalesPriceModelsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    salesPriceModelsGet(
      requestParameters: SalesPriceModelsApiSalesPriceModelsGetRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<Array<SalesPriceModel>> {
      return localVarFp
        .salesPriceModelsGet(requestParameters.planId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Import export sales price model in JSON format
     * @param {SalesPriceModelsApiSalesPriceModelsImportJSONPlanIdPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    salesPriceModelsImportJSONPlanIdPost(
      requestParameters: SalesPriceModelsApiSalesPriceModelsImportJSONPlanIdPostRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<SalesPriceModel> {
      return localVarFp
        .salesPriceModelsImportJSONPlanIdPost(
          requestParameters.planId,
          requestParameters.migrateSalesPriceModel,
          options,
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Import sales prices from Excel file
     * @param {SalesPriceModelsApiSalesPriceModelsImportPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    salesPriceModelsImportPost(
      requestParameters: SalesPriceModelsApiSalesPriceModelsImportPostRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<SalesPriceModel> {
      return localVarFp
        .salesPriceModelsImportPost(
          requestParameters.file,
          requestParameters.name,
          requestParameters.planId,
          requestParameters.type,
          options,
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    salesPriceModelsImportTemplateGet(options?: RawAxiosRequestConfig): AxiosPromise<File> {
      return localVarFp.salesPriceModelsImportTemplateGet(options).then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Delete sales price model by its identifier
     * @param {SalesPriceModelsApiSalesPriceModelsModelIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    salesPriceModelsModelIdDelete(
      requestParameters: SalesPriceModelsApiSalesPriceModelsModelIdDeleteRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<void> {
      return localVarFp
        .salesPriceModelsModelIdDelete(requestParameters.modelId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Export sales price model as JSON
     * @param {SalesPriceModelsApiSalesPriceModelsModelIdExportGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    salesPriceModelsModelIdExportGet(
      requestParameters: SalesPriceModelsApiSalesPriceModelsModelIdExportGetRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<MigrateSalesPriceModel> {
      return localVarFp
        .salesPriceModelsModelIdExportGet(requestParameters.modelId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Get sales price model by its identifier
     * @param {SalesPriceModelsApiSalesPriceModelsModelIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    salesPriceModelsModelIdGet(
      requestParameters: SalesPriceModelsApiSalesPriceModelsModelIdGetRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<SalesPriceModel> {
      return localVarFp
        .salesPriceModelsModelIdGet(requestParameters.modelId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Update sales price model name
     * @param {SalesPriceModelsApiSalesPriceModelsModelIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    salesPriceModelsModelIdPut(
      requestParameters: SalesPriceModelsApiSalesPriceModelsModelIdPutRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<SalesPriceModel> {
      return localVarFp
        .salesPriceModelsModelIdPut(requestParameters.modelId, requestParameters.salesPriceModel, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Delete sales price row by its identifier (fromDate)
     * @param {SalesPriceModelsApiSalesPriceModelsModelIdRowsFromDateDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    salesPriceModelsModelIdRowsFromDateDelete(
      requestParameters: SalesPriceModelsApiSalesPriceModelsModelIdRowsFromDateDeleteRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<void> {
      return localVarFp
        .salesPriceModelsModelIdRowsFromDateDelete(requestParameters.modelId, requestParameters.fromDate, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Update single sales price
     * @param {SalesPriceModelsApiSalesPriceModelsModelIdRowsFromDatePatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    salesPriceModelsModelIdRowsFromDatePatch(
      requestParameters: SalesPriceModelsApiSalesPriceModelsModelIdRowsFromDatePatchRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<void> {
      return localVarFp
        .salesPriceModelsModelIdRowsFromDatePatch(
          requestParameters.modelId,
          requestParameters.fromDate,
          requestParameters.editSalesPriceModelCell,
          options,
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Update sales price row originally identified by the \'fromDate\' passed in the route
     * @param {SalesPriceModelsApiSalesPriceModelsModelIdRowsFromDatePutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    salesPriceModelsModelIdRowsFromDatePut(
      requestParameters: SalesPriceModelsApiSalesPriceModelsModelIdRowsFromDatePutRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<SalesPriceModelRow> {
      return localVarFp
        .salesPriceModelsModelIdRowsFromDatePut(
          requestParameters.modelId,
          requestParameters.fromDate,
          requestParameters.salesPriceModelRow,
          options,
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Get all rows for the sales price model with \'modelId\'
     * @param {SalesPriceModelsApiSalesPriceModelsModelIdRowsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    salesPriceModelsModelIdRowsGet(
      requestParameters: SalesPriceModelsApiSalesPriceModelsModelIdRowsGetRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<Array<SalesPriceModelRow>> {
      return localVarFp
        .salesPriceModelsModelIdRowsGet(requestParameters.modelId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Add row to sales price model with \'modelId\'
     * @param {SalesPriceModelsApiSalesPriceModelsModelIdRowsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    salesPriceModelsModelIdRowsPost(
      requestParameters: SalesPriceModelsApiSalesPriceModelsModelIdRowsPostRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<SalesPriceModelRow> {
      return localVarFp
        .salesPriceModelsModelIdRowsPost(requestParameters.modelId, requestParameters.salesPriceModelRow, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Create sales price model for user\'s tenant
     * @param {SalesPriceModelsApiSalesPriceModelsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    salesPriceModelsPost(
      requestParameters: SalesPriceModelsApiSalesPriceModelsPostRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<SalesPriceModel> {
      return localVarFp
        .salesPriceModelsPost(requestParameters.addSalesPriceModel, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Get all types of sales price models and the corresponding weight classes
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    salesPriceModelsTypesGet(options?: RawAxiosRequestConfig): AxiosPromise<Array<SalesClassModelType>> {
      return localVarFp.salesPriceModelsTypesGet(options).then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Get sales price model type by its identifier
     * @param {SalesPriceModelsApiSalesPriceModelsTypesModelTypeGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    salesPriceModelsTypesModelTypeGet(
      requestParameters: SalesPriceModelsApiSalesPriceModelsTypesModelTypeGetRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<SalesClassModelType> {
      return localVarFp
        .salesPriceModelsTypesModelTypeGet(requestParameters.modelType, options)
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * Request parameters for salesPriceModelsCopyPost operation in SalesPriceModelsApi.
 * @export
 * @interface SalesPriceModelsApiSalesPriceModelsCopyPostRequest
 */
export interface SalesPriceModelsApiSalesPriceModelsCopyPostRequest {
  /**
   *
   * @type {CopySalesPriceModel}
   * @memberof SalesPriceModelsApiSalesPriceModelsCopyPost
   */
  readonly copySalesPriceModel: CopySalesPriceModel;
}

/**
 * Request parameters for salesPriceModelsGet operation in SalesPriceModelsApi.
 * @export
 * @interface SalesPriceModelsApiSalesPriceModelsGetRequest
 */
export interface SalesPriceModelsApiSalesPriceModelsGetRequest {
  /**
   *
   * @type {string}
   * @memberof SalesPriceModelsApiSalesPriceModelsGet
   */
  readonly planId: string;
}

/**
 * Request parameters for salesPriceModelsImportJSONPlanIdPost operation in SalesPriceModelsApi.
 * @export
 * @interface SalesPriceModelsApiSalesPriceModelsImportJSONPlanIdPostRequest
 */
export interface SalesPriceModelsApiSalesPriceModelsImportJSONPlanIdPostRequest {
  /**
   *
   * @type {string}
   * @memberof SalesPriceModelsApiSalesPriceModelsImportJSONPlanIdPost
   */
  readonly planId: string;

  /**
   *
   * @type {MigrateSalesPriceModel}
   * @memberof SalesPriceModelsApiSalesPriceModelsImportJSONPlanIdPost
   */
  readonly migrateSalesPriceModel: MigrateSalesPriceModel;
}

/**
 * Request parameters for salesPriceModelsImportPost operation in SalesPriceModelsApi.
 * @export
 * @interface SalesPriceModelsApiSalesPriceModelsImportPostRequest
 */
export interface SalesPriceModelsApiSalesPriceModelsImportPostRequest {
  /**
   *
   * @type {File}
   * @memberof SalesPriceModelsApiSalesPriceModelsImportPost
   */
  readonly file: File;

  /**
   *
   * @type {string}
   * @memberof SalesPriceModelsApiSalesPriceModelsImportPost
   */
  readonly name: string;

  /**
   *
   * @type {string}
   * @memberof SalesPriceModelsApiSalesPriceModelsImportPost
   */
  readonly planId: string;

  /**
   *
   * @type {string}
   * @memberof SalesPriceModelsApiSalesPriceModelsImportPost
   */
  readonly type: string;
}

/**
 * Request parameters for salesPriceModelsModelIdDelete operation in SalesPriceModelsApi.
 * @export
 * @interface SalesPriceModelsApiSalesPriceModelsModelIdDeleteRequest
 */
export interface SalesPriceModelsApiSalesPriceModelsModelIdDeleteRequest {
  /**
   *
   * @type {string}
   * @memberof SalesPriceModelsApiSalesPriceModelsModelIdDelete
   */
  readonly modelId: string;
}

/**
 * Request parameters for salesPriceModelsModelIdExportGet operation in SalesPriceModelsApi.
 * @export
 * @interface SalesPriceModelsApiSalesPriceModelsModelIdExportGetRequest
 */
export interface SalesPriceModelsApiSalesPriceModelsModelIdExportGetRequest {
  /**
   *
   * @type {string}
   * @memberof SalesPriceModelsApiSalesPriceModelsModelIdExportGet
   */
  readonly modelId: string;
}

/**
 * Request parameters for salesPriceModelsModelIdGet operation in SalesPriceModelsApi.
 * @export
 * @interface SalesPriceModelsApiSalesPriceModelsModelIdGetRequest
 */
export interface SalesPriceModelsApiSalesPriceModelsModelIdGetRequest {
  /**
   *
   * @type {string}
   * @memberof SalesPriceModelsApiSalesPriceModelsModelIdGet
   */
  readonly modelId: string;
}

/**
 * Request parameters for salesPriceModelsModelIdPut operation in SalesPriceModelsApi.
 * @export
 * @interface SalesPriceModelsApiSalesPriceModelsModelIdPutRequest
 */
export interface SalesPriceModelsApiSalesPriceModelsModelIdPutRequest {
  /**
   *
   * @type {string}
   * @memberof SalesPriceModelsApiSalesPriceModelsModelIdPut
   */
  readonly modelId: string;

  /**
   *
   * @type {SalesPriceModel}
   * @memberof SalesPriceModelsApiSalesPriceModelsModelIdPut
   */
  readonly salesPriceModel: SalesPriceModel;
}

/**
 * Request parameters for salesPriceModelsModelIdRowsFromDateDelete operation in SalesPriceModelsApi.
 * @export
 * @interface SalesPriceModelsApiSalesPriceModelsModelIdRowsFromDateDeleteRequest
 */
export interface SalesPriceModelsApiSalesPriceModelsModelIdRowsFromDateDeleteRequest {
  /**
   *
   * @type {string}
   * @memberof SalesPriceModelsApiSalesPriceModelsModelIdRowsFromDateDelete
   */
  readonly modelId: string;

  /**
   *
   * @type {string}
   * @memberof SalesPriceModelsApiSalesPriceModelsModelIdRowsFromDateDelete
   */
  readonly fromDate: string;
}

/**
 * Request parameters for salesPriceModelsModelIdRowsFromDatePatch operation in SalesPriceModelsApi.
 * @export
 * @interface SalesPriceModelsApiSalesPriceModelsModelIdRowsFromDatePatchRequest
 */
export interface SalesPriceModelsApiSalesPriceModelsModelIdRowsFromDatePatchRequest {
  /**
   *
   * @type {string}
   * @memberof SalesPriceModelsApiSalesPriceModelsModelIdRowsFromDatePatch
   */
  readonly modelId: string;

  /**
   *
   * @type {string}
   * @memberof SalesPriceModelsApiSalesPriceModelsModelIdRowsFromDatePatch
   */
  readonly fromDate: string;

  /**
   *
   * @type {EditSalesPriceModelCell}
   * @memberof SalesPriceModelsApiSalesPriceModelsModelIdRowsFromDatePatch
   */
  readonly editSalesPriceModelCell: EditSalesPriceModelCell;
}

/**
 * Request parameters for salesPriceModelsModelIdRowsFromDatePut operation in SalesPriceModelsApi.
 * @export
 * @interface SalesPriceModelsApiSalesPriceModelsModelIdRowsFromDatePutRequest
 */
export interface SalesPriceModelsApiSalesPriceModelsModelIdRowsFromDatePutRequest {
  /**
   *
   * @type {string}
   * @memberof SalesPriceModelsApiSalesPriceModelsModelIdRowsFromDatePut
   */
  readonly modelId: string;

  /**
   *
   * @type {string}
   * @memberof SalesPriceModelsApiSalesPriceModelsModelIdRowsFromDatePut
   */
  readonly fromDate: string;

  /**
   *
   * @type {SalesPriceModelRow}
   * @memberof SalesPriceModelsApiSalesPriceModelsModelIdRowsFromDatePut
   */
  readonly salesPriceModelRow: SalesPriceModelRow;
}

/**
 * Request parameters for salesPriceModelsModelIdRowsGet operation in SalesPriceModelsApi.
 * @export
 * @interface SalesPriceModelsApiSalesPriceModelsModelIdRowsGetRequest
 */
export interface SalesPriceModelsApiSalesPriceModelsModelIdRowsGetRequest {
  /**
   *
   * @type {string}
   * @memberof SalesPriceModelsApiSalesPriceModelsModelIdRowsGet
   */
  readonly modelId: string;
}

/**
 * Request parameters for salesPriceModelsModelIdRowsPost operation in SalesPriceModelsApi.
 * @export
 * @interface SalesPriceModelsApiSalesPriceModelsModelIdRowsPostRequest
 */
export interface SalesPriceModelsApiSalesPriceModelsModelIdRowsPostRequest {
  /**
   *
   * @type {string}
   * @memberof SalesPriceModelsApiSalesPriceModelsModelIdRowsPost
   */
  readonly modelId: string;

  /**
   *
   * @type {SalesPriceModelRow}
   * @memberof SalesPriceModelsApiSalesPriceModelsModelIdRowsPost
   */
  readonly salesPriceModelRow: SalesPriceModelRow;
}

/**
 * Request parameters for salesPriceModelsPost operation in SalesPriceModelsApi.
 * @export
 * @interface SalesPriceModelsApiSalesPriceModelsPostRequest
 */
export interface SalesPriceModelsApiSalesPriceModelsPostRequest {
  /**
   *
   * @type {AddSalesPriceModel}
   * @memberof SalesPriceModelsApiSalesPriceModelsPost
   */
  readonly addSalesPriceModel: AddSalesPriceModel;
}

/**
 * Request parameters for salesPriceModelsTypesModelTypeGet operation in SalesPriceModelsApi.
 * @export
 * @interface SalesPriceModelsApiSalesPriceModelsTypesModelTypeGetRequest
 */
export interface SalesPriceModelsApiSalesPriceModelsTypesModelTypeGetRequest {
  /**
   *
   * @type {string}
   * @memberof SalesPriceModelsApiSalesPriceModelsTypesModelTypeGet
   */
  readonly modelType: string;
}

/**
 * SalesPriceModelsApi - object-oriented interface
 * @export
 * @class SalesPriceModelsApi
 * @extends {BaseAPI}
 */
export class SalesPriceModelsApi extends BaseAPI {
  /**
   *
   * @summary Copy a sales price model
   * @param {SalesPriceModelsApiSalesPriceModelsCopyPostRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SalesPriceModelsApi
   */
  public salesPriceModelsCopyPost(
    requestParameters: SalesPriceModelsApiSalesPriceModelsCopyPostRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return SalesPriceModelsApiFp(this.configuration)
      .salesPriceModelsCopyPost(requestParameters.copySalesPriceModel, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Get all sales price models for user\'s tenant
   * @param {SalesPriceModelsApiSalesPriceModelsGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SalesPriceModelsApi
   */
  public salesPriceModelsGet(
    requestParameters: SalesPriceModelsApiSalesPriceModelsGetRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return SalesPriceModelsApiFp(this.configuration)
      .salesPriceModelsGet(requestParameters.planId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Import export sales price model in JSON format
   * @param {SalesPriceModelsApiSalesPriceModelsImportJSONPlanIdPostRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SalesPriceModelsApi
   */
  public salesPriceModelsImportJSONPlanIdPost(
    requestParameters: SalesPriceModelsApiSalesPriceModelsImportJSONPlanIdPostRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return SalesPriceModelsApiFp(this.configuration)
      .salesPriceModelsImportJSONPlanIdPost(requestParameters.planId, requestParameters.migrateSalesPriceModel, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Import sales prices from Excel file
   * @param {SalesPriceModelsApiSalesPriceModelsImportPostRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SalesPriceModelsApi
   */
  public salesPriceModelsImportPost(
    requestParameters: SalesPriceModelsApiSalesPriceModelsImportPostRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return SalesPriceModelsApiFp(this.configuration)
      .salesPriceModelsImportPost(
        requestParameters.file,
        requestParameters.name,
        requestParameters.planId,
        requestParameters.type,
        options,
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SalesPriceModelsApi
   */
  public salesPriceModelsImportTemplateGet(options?: RawAxiosRequestConfig) {
    return SalesPriceModelsApiFp(this.configuration)
      .salesPriceModelsImportTemplateGet(options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Delete sales price model by its identifier
   * @param {SalesPriceModelsApiSalesPriceModelsModelIdDeleteRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SalesPriceModelsApi
   */
  public salesPriceModelsModelIdDelete(
    requestParameters: SalesPriceModelsApiSalesPriceModelsModelIdDeleteRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return SalesPriceModelsApiFp(this.configuration)
      .salesPriceModelsModelIdDelete(requestParameters.modelId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Export sales price model as JSON
   * @param {SalesPriceModelsApiSalesPriceModelsModelIdExportGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SalesPriceModelsApi
   */
  public salesPriceModelsModelIdExportGet(
    requestParameters: SalesPriceModelsApiSalesPriceModelsModelIdExportGetRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return SalesPriceModelsApiFp(this.configuration)
      .salesPriceModelsModelIdExportGet(requestParameters.modelId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Get sales price model by its identifier
   * @param {SalesPriceModelsApiSalesPriceModelsModelIdGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SalesPriceModelsApi
   */
  public salesPriceModelsModelIdGet(
    requestParameters: SalesPriceModelsApiSalesPriceModelsModelIdGetRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return SalesPriceModelsApiFp(this.configuration)
      .salesPriceModelsModelIdGet(requestParameters.modelId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Update sales price model name
   * @param {SalesPriceModelsApiSalesPriceModelsModelIdPutRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SalesPriceModelsApi
   */
  public salesPriceModelsModelIdPut(
    requestParameters: SalesPriceModelsApiSalesPriceModelsModelIdPutRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return SalesPriceModelsApiFp(this.configuration)
      .salesPriceModelsModelIdPut(requestParameters.modelId, requestParameters.salesPriceModel, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Delete sales price row by its identifier (fromDate)
   * @param {SalesPriceModelsApiSalesPriceModelsModelIdRowsFromDateDeleteRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SalesPriceModelsApi
   */
  public salesPriceModelsModelIdRowsFromDateDelete(
    requestParameters: SalesPriceModelsApiSalesPriceModelsModelIdRowsFromDateDeleteRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return SalesPriceModelsApiFp(this.configuration)
      .salesPriceModelsModelIdRowsFromDateDelete(requestParameters.modelId, requestParameters.fromDate, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Update single sales price
   * @param {SalesPriceModelsApiSalesPriceModelsModelIdRowsFromDatePatchRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SalesPriceModelsApi
   */
  public salesPriceModelsModelIdRowsFromDatePatch(
    requestParameters: SalesPriceModelsApiSalesPriceModelsModelIdRowsFromDatePatchRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return SalesPriceModelsApiFp(this.configuration)
      .salesPriceModelsModelIdRowsFromDatePatch(
        requestParameters.modelId,
        requestParameters.fromDate,
        requestParameters.editSalesPriceModelCell,
        options,
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Update sales price row originally identified by the \'fromDate\' passed in the route
   * @param {SalesPriceModelsApiSalesPriceModelsModelIdRowsFromDatePutRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SalesPriceModelsApi
   */
  public salesPriceModelsModelIdRowsFromDatePut(
    requestParameters: SalesPriceModelsApiSalesPriceModelsModelIdRowsFromDatePutRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return SalesPriceModelsApiFp(this.configuration)
      .salesPriceModelsModelIdRowsFromDatePut(
        requestParameters.modelId,
        requestParameters.fromDate,
        requestParameters.salesPriceModelRow,
        options,
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Get all rows for the sales price model with \'modelId\'
   * @param {SalesPriceModelsApiSalesPriceModelsModelIdRowsGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SalesPriceModelsApi
   */
  public salesPriceModelsModelIdRowsGet(
    requestParameters: SalesPriceModelsApiSalesPriceModelsModelIdRowsGetRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return SalesPriceModelsApiFp(this.configuration)
      .salesPriceModelsModelIdRowsGet(requestParameters.modelId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Add row to sales price model with \'modelId\'
   * @param {SalesPriceModelsApiSalesPriceModelsModelIdRowsPostRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SalesPriceModelsApi
   */
  public salesPriceModelsModelIdRowsPost(
    requestParameters: SalesPriceModelsApiSalesPriceModelsModelIdRowsPostRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return SalesPriceModelsApiFp(this.configuration)
      .salesPriceModelsModelIdRowsPost(requestParameters.modelId, requestParameters.salesPriceModelRow, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Create sales price model for user\'s tenant
   * @param {SalesPriceModelsApiSalesPriceModelsPostRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SalesPriceModelsApi
   */
  public salesPriceModelsPost(
    requestParameters: SalesPriceModelsApiSalesPriceModelsPostRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return SalesPriceModelsApiFp(this.configuration)
      .salesPriceModelsPost(requestParameters.addSalesPriceModel, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Get all types of sales price models and the corresponding weight classes
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SalesPriceModelsApi
   */
  public salesPriceModelsTypesGet(options?: RawAxiosRequestConfig) {
    return SalesPriceModelsApiFp(this.configuration)
      .salesPriceModelsTypesGet(options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Get sales price model type by its identifier
   * @param {SalesPriceModelsApiSalesPriceModelsTypesModelTypeGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SalesPriceModelsApi
   */
  public salesPriceModelsTypesModelTypeGet(
    requestParameters: SalesPriceModelsApiSalesPriceModelsTypesModelTypeGetRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return SalesPriceModelsApiFp(this.configuration)
      .salesPriceModelsTypesModelTypeGet(requestParameters.modelType, options)
      .then((request) => request(this.axios, this.basePath));
  }
}
